import type { WorkspaceColorScheme } from '@/features/iam/workspaces/workspace-branding'
import type { PreselectedWorkspaceProvider } from '@/features/iam/workspaces/PreselectedWorkspaceProvider'

/**
 * Reads the workspace theme from the preselected workspace if possible.
 *
 * @param preselectedWorkspaceProvider
 */
export function getPreselectedWorkspaceThemeColors(
  preselectedWorkspaceProvider: PreselectedWorkspaceProvider,
): WorkspaceColorScheme | null {
  const preselection = preselectedWorkspaceProvider.read()
  if (preselection?.type === 'Url') {
    return {
      primary: preselection.workspaceResource.branding.colors.primary,
      primaryDark:
        preselection.workspaceResource.branding.colors.primary_dark || null,
    }
  }

  return null
}
